import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import OrderingMenu from "../components/OrderingMenu";
import FeaturedDishes from "../components/FeaturedDishes";
import DealsStrip from "../components/DealsStrip";
import Gallery from "../components/Gallery";
import AboutUs from "../components/AboutUs";
import DeliveryPartners from "../components/DeliveryPartners";
import ContactBand from "../components/ContactBand";
import Footer from "../components/Footer";

export default function Home() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const target = location.state && location.state.scrollTo;
    if (!target) return undefined;
    const t = setTimeout(() => {
      const el = document.querySelector(target);
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76 });
      else el.scrollIntoView({ behavior: "smooth" });
      navigate("/", { replace: true, state: null });
    }, 400);
    return () => clearTimeout(t);
  }, [location.state, navigate]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <OrderingMenu />
        <FeaturedDishes />
        <DealsStrip />
        <Gallery />
        <AboutUs />
        <DeliveryPartners />
        <ContactBand />
      </main>
      <Footer />
    </div>
  );
}
